import { render, staticRenderFns } from "./MessageQueueDeadLettersTable.vue?vue&type=template&id=69739e48"
import script from "./MessageQueueDeadLettersTable.vue?vue&type=script&lang=js"
export * from "./MessageQueueDeadLettersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports